<template>
  <div class="youtube-list-section">
    <h3 v-if="title && isVideoLinks" class="youtube-list-section__title">{{ title }}</h3>

    <carousel-list-wrapper-parts
      class="youtube-list-section__list"
      :enabledCarouselList="enabledCarouselList"
      carouselListType="video"
    >
      <video-link-card-parts
        v-for="(videoLink, index) in videoLinks"
        :class="`youtube-list-section__list-item${index}`"
        :key="`${videoLink.img}-${index}`"
        :videoLink="videoLink"
        :membership="membershipType"
        @click="onVideoSelected(videoLink)"
      />
    </carousel-list-wrapper-parts>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/composition-api'
import CarouselListWrapperParts from '@/components/HomePage/HomePane/parts/CarouselListWrapperParts.vue'
import videoLinkCardParts, {
  VideoLinkCardData,
  VideoLinkCardMembershipData,
} from '@/components/HomePage/HomePane/parts/VideoLinkCardParts.vue'

/**
 * HOME Youtubeリストセクション
 */
export default defineComponent({
  name: 'YoutubeListSection',
  components: {
    CarouselListWrapperParts,
    videoLinkCardParts,
  },
  props: {
    title: {
      type: String,
    },
    videoLinks: {
      type: Array as PropType<VideoLinkCardData[]>,
      required: true,
    },
    membershipType: {
      type: String as PropType<VideoLinkCardMembershipData>,
      default: 'free',
    },
    enabledCarouselList: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    /** 動画データが存在しているか */
    const isVideoLinks = computed(() => props.videoLinks.length)
    return { isVideoLinks }
  },
  methods: {
    /**
     * Youtubeカードが選択された場合に呼び出される。
     */
    onVideoSelected(videoCardData: VideoLinkCardData) {
      this.$emit('videoSelected', videoCardData)
    },
  },
})
</script>

<style lang="scss" scoped>
.youtube-list-section {
  width: 100%;
  padding: 24px 0;
  overflow: hidden;
  text-align: left;

  &__title {
    width: 100%;
    max-width: $responsiveTabletWidth;
    margin: 0 auto 18px;
    padding: 0 16px;
    @include fontSetTitleBold(16);

    text-transform: none;
    font-family: $fontSignup;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-align: left;
    font-feature-settings: 'palt' on;
    color: #000000;
  }
}
</style>
